<template>
  <common-contribute-activity
    :preparatoryBackgroundImage="bgImage"
    :submissionBackgroundImage="bgImage"
    :votingBackgroundImage="bgVotingImage"
    rankPath="contribute-scorpio-rank"
    votesType="20241201"
  ></common-contribute-activity>
</template>
<script>
import CommonContributeActivity from '@/components/common-contribute-activity';
import bgImage from './images/bg.jpg';
import bgVotingImage from './images/bg-voting.png';

export default {
  name: 'ContributeScorpio',
  components: {
    CommonContributeActivity
  },
  props: {},
  data() {
    return {
      bgImage,
      bgVotingImage
    };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>
